<style scoped>
.registrationtable td,
.registrationtable th {
  border: 1px solid #ddd;
  padding: 8px;
}

.document td,
.document th {
  padding: 8px;
}

.technicaltable td,
.technicaltable th {
  border: 1px;
  padding: 8px;
}

.row {
  height: 100% !important;
}
</style>
<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <NoticeList class="order-3" phaseId="4" :regId="this.$route.params.id" />

      </v-col>
      <v-col cols="12" md="6">
        <UploadDocumentList phaseId="4" :submitStatus="submitStatus" />


        <RegistrationAction v-if="this.$store.getters.forwardRevertActionAuthData" :regPhaseId="this.results.phase_id" :regDeskId="this.results.desk_user_role_id"
          :regCreatedByConsultancy="this.results.is_created_by_consultancy" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import RegistrationAction from "../subComponents/RegistrationAction.vue";
//   import Application from '../../../modules/tabbedElements/components/Application.vue';
import api from "@/api/api";

import NoticeList from "./NoticeList.vue";
import UploadDocumentList from "./UploadDocumentList.vue";

export default {
  name: "Application",
  props: {
    nextStep: {
      type: Function,
    },
    id: {
      type: Number,
    },
    currentApplicationPhase: {
      type: [String, Number],
    },
    currentApplicationDesk: {
      type: [String, Number],
    },
    submitStatus: {
      type: Object,
    },
  },
  components: {
    RegistrationAction,
    NoticeList,
    UploadDocumentList
  },
  mounted() {
    this.getRegistrationData();
  },
  data() {
    return {
      opened: 0,
      user_role_id: localStorage.getItem("auth_user_role_id"),
      results: [],
      isDocumentAddEditAuthorized: false,
      documents: [],
    };
  },
  created() {
  },
  methods: {
    async getRegistrationData() {
      let regDataTemp = this.$store.getters.registrationData;
      try {
        if (!Object.keys(regDataTemp).length || regDataTemp.id != this.$route.params.id) {
          await this.$store.dispatch("getRegistration", this.$route.params.id)
        }
        this.results = this.$store.getters.registrationData;
      }
      catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
#styled-input {
  height: 30px;
  font-size: 20pt;
}

.styled-input label[for] {
  height: 30px;
  font-size: 20pt;
}

.row,
.col {
  height: 58px;
}

.custom-text-field.v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0;
}
</style>
